import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { PasscodeGate } from './components/ui/PasscodeGate';
import { Home } from './pages/Home';
import { Bids } from './pages/Bids';
import { Projects } from './pages/Projects';
import { AnnualPlan } from './pages/AnnualPlan';
import { ContractAwards } from './pages/ContractAwards';
import { UnsuccessfulBids } from './pages/UnsuccessfulBids';
import { ProcurementManual } from './pages/ProcurementManual';
import { SupplierRegistration } from './pages/SupplierRegistration';
import { Contact } from './pages/Contact';
import { About } from './pages/About';
import { AboutAU } from './pages/AboutAU';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route element={<Layout data-id="element-3" />} data-id="element-2">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<About data-id="element-7" />} data-id="element-6" />
          <Route path="/about-au" element={<AboutAU data-id="element-9" />} data-id="element-8" />
          <Route path="/projects" element={<Projects data-id="element-11" />} data-id="element-10" />
          <Route path="/bids" element={<PasscodeGate data-id="element-13">
                <Bids data-id="element-14" />
              </PasscodeGate>} data-id="element-12" />
          <Route path="/procurement/annual-plan" element={<AnnualPlan data-id="element-16" />} data-id="element-15" />
          <Route path="/procurement/contract-awards" element={<ContractAwards data-id="element-18" />} data-id="element-17" />
          <Route path="/procurement/unsuccessful-bids" element={<UnsuccessfulBids data-id="element-20" />} data-id="element-19" />
          <Route path="/procurement/manual" element={<ProcurementManual data-id="element-22" />} data-id="element-21" />
          <Route path="/procurement/supplier-registration" element={<SupplierRegistration data-id="element-24" />} data-id="element-23" />
          <Route path="/contact" element={<Contact data-id="element-26" />} data-id="element-25" />
        </Route>
      </Routes>
    </BrowserRouter>;
}